/**
 * Helpers to bridge the tenant `codeFlags` object map (how the backend stores /
 * expects them: `{ [flagName]: boolean | string }`) and the array shape
 * react-hook-form's `useFieldArray` needs so flag names, types, and values can be
 * edited freely.
 *
 * Each row is `{ key, type, boolValue, stringValue }` where `type` is
 * `'boolean' | 'string'`. Boolean and string values are kept in separate fields so
 * swapping a row's type never coerces one into the other; only the field matching
 * the row's `type` is serialized back into the map.
 */

export const codeFlagsToFieldArray = (codeFlags = {}) =>
  Object.entries(codeFlags || {}).map(([key, value]) => {
    const isString = typeof value === 'string';
    return {
      key,
      type: isString ? 'string' : 'boolean',
      boolValue: isString ? false : Boolean(value),
      stringValue: isString ? value : '',
    };
  });

export const codeFlagValueFromRow = ({ type, boolValue, stringValue } = {}) =>
  type === 'string' ? stringValue ?? '' : Boolean(boolValue);

export const fieldArrayToCodeFlags = (rows = []) =>
  (rows || []).reduce((acc, row = {}) => {
    const trimmedKey = (row.key || '').trim();
    if (trimmedKey) {
      acc[trimmedKey] = codeFlagValueFromRow(row);
    }
    return acc;
  }, {});
